import {useModel} from '@umijs/max';
import React, {useEffect, useState} from 'react';
import {CheckCard, ProCard} from "@ant-design/pro-components";
import {Button, Card, Col, Form, Image, Input, message, Modal, Row, Select, Space, Spin, Tag, Typography} from "antd";
import {createEnvFromPlatform, findProductByBizType, getEnterpriseProfileOrderInfo} from "./ISWAN_MARKET/service";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import EnterpriseAuthForm from './ISWAN_BASE/PerEnterprise/components/EnterpriseAuthForm';
import CustomerModal from "@/components/RightContent/CustomerModal";
import ProcessEnv from "@/pages/ProcessEnv";
import {getCurrent, searchEnterprise} from "@/services/service";
import {ContactUtils} from "@/util/ContactUtils";
import {isMobile} from "react-device-detect";
import './prepareEnv.fix.css'
import {useThrottleFn} from "ahooks";
import {appendRegCodeToUrl, getStoredRegCode} from "@/util/regCode";

const PrepareEnv = (props) => {
  const {enterpriseId, enterpriseName, enterpriseCode, fromPage} = props;
  const {initialState} = useModel('@@initialState');
  const [modal, contextHolder] = Modal.useModal();
  const [result, setResult] = useState({}); //表单对象值
  const [productEnvs, setProductEnvs] = useState([]); //表单对象值
  const [form] = Form.useForm();
  const [orderedDeployId, setOrderedDeployId] = useState(null); //表单对象值
  const [updateModalVisible, handleUpdateModalVisible] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [visibleForCustomer, setVisibleForCustomer] = useState(false);
  const [currentProductEnv, setCurrentProductEnv] = useState(null);
  const [showProcessEnv, setShowProcessEnv] = useState(false);
  const [currentUserTemp, setCurrentUserTemp] = useState({});

  const [enterpriseNameOptions, setEnterpriseNameOptions] = useState<{label: string, value: string}[]>([])
  const [enterpriseNameFetching, setEnterpriseNameFetching] = useState(false)
  const { run: handleSearch } = useThrottleFn(
    async (keyword: string) => {
      if (/^[a-z]{0,2}$/.test(keyword)) {
        setEnterpriseNameOptions([])
        return
      }
      setEnterpriseNameFetching(true)
      setEnterpriseNameOptions([])
      const data = await searchEnterprise({ keyword }) as { name: string }[];
      setEnterpriseNameFetching(false)
      setEnterpriseNameOptions(data.map(e => ({ label: e.name, value: e.name })))
    },
    { wait: 1000 },
  );

  useEffect(() => {
    const fetchData = async () => {

      let orderInfo = await getEnterpriseProfileOrderInfo({});
      console.log({orderInfo})
      if (!orderInfo) {
        orderInfo = {};
      }
      setOrderedDeployId(orderInfo.deployId);

      let resForProductEnv = await findProductByBizType({bizType: 'PRODUCT_ENV'});
      setProductEnvs(resForProductEnv || []);
      setCurrentProductEnv(resForProductEnv.find((item: any, index: number) => item.id != orderInfo.deployId) || {});
      setResult({
        deployId: resForProductEnv.find((item: any, index: number) => item.id != orderInfo.deployId).id + '',
      })

      if (!enterpriseId && initialState?.currentUser?.enterpriseId) {
        let res = await getCurrent();
        setCurrentUserTemp(res);
      }

    };
    fetchData();
  }, []);

  const calculatePayPrice = (deployId) => {
    console.log('deployId', deployId);
    let payPrice = 0;
    if (deployId) {
      console.log('deployId', deployId)
      if (productEnvs && productEnvs.length > 0) {
        //去掉已经存在的费用
        let orderedDeployIdPrice = 0;
        if (orderedDeployId) {
          let findItem = productEnvs.find((item: any) => orderedDeployId + '' === item.id + '');
          if (findItem) {
            orderedDeployIdPrice = findItem.salePrice;
          }
        }
        productEnvs.filter((item: any) => deployId + '' === item.id + '').forEach((item: any) => {
          payPrice = payPrice + item.salePrice;
        })
        payPrice = payPrice - orderedDeployIdPrice;
      }
    }

    console.log('payPrice', payPrice)
    setResult({
      deployId: deployId, payPrice: payPrice
    })
  }

  return (
    <>
      {
        showProcessEnv && fromPage === 'admin' && (
          <ProcessEnv fromPage={'admin'} enterpriseCode={enterpriseCode || initialState?.currentUser?.enterpriseCode}/>
        )
      }

      {
        showProcessEnv && fromPage !== 'admin' && isMobile && initialState?.currentUser?.enterpriseCode   && initialState?.currentUser?.mobile && (
          <ProcessEnv  enterpriseCode={initialState?.currentUser?.enterpriseCode}  mobile={initialState?.currentUser?.mobile}/>
        )
      }

      {
        !showProcessEnv && Object.keys(result).length > 0 && (
          <Form form={form}  layout={isMobile ? "vertical" : 'horizontal'} initialValues={{
            deployId: result.deployId,
            enterpriseName: enterpriseName || (initialState?.currentUser?.enterpriseCode === 'iyb'?'': initialState?.currentUser?.enterpriseName),
          }}>
            <ProCard style={{textAlign: "center", height: 'calc(100vh - 210px)'}}>
              <div style={{width: '100%', margin: '0 auto'}}>
                <Typography.Title level={2} style={{margin: '10px 0px 20px 0px'}}>选择产品</Typography.Title>
                <div className={`__fix__prepareEnvMobileSelect`} style={{width: '100%', overflowX: 'scroll'}}>
                  <Form.Item name="deployId">
                    <CheckCard.Group
                      size={"large"}
                      style={{width: '100%', display: 'flex', justifyContent: 'center', maxWidth: 'none'}}
                      onChange={(value) => {
                        console.log(value)
                        if (!value) {
                          console.log('!value', value)
                          form.setFieldsValue({deployId: result.deployId});
                          return;
                          // return modal.warning({centered: true, title: '系统提示', content: '请至少选择一个部署环境'});
                        } else {
                          setCurrentProductEnv(productEnvs.find(item => item.id + '' === value) || {});
                        }
                        setResult({...result, deployId: value});
                        calculatePayPrice(value);
                      }}
                    >
                      {
                        productEnvs.map((item, index) => {
                          return (
                            <CheckCard
                              style={{width: isMobile ? (window.innerWidth - 48) + 'px' : undefined}}
                              disabled={orderedDeployId == item.id + ''}
                              key={item.id + ''}
                              title={(
                                <Space>
                                  <Image width={80}
                                         preview={false}
                                         src={item.mainPic}/>
                                  <Space direction={"vertical"}>
                                    <Space>
                                      <span style={{fontWeight: "bold"}}>{item.name}</span>
                                      {
                                        item.unit === '面议' && (
                                          <Tag color="#f50">{item.unit}</Tag>
                                        )
                                      }
                                      {
                                        item.unit !== '面议' && (
                                          <span>¥{item.salePrice}{item.unit === '年' ? '/年' : ''}</span>
                                        )
                                      }
                                      {
                                        item.recommend === 'Y' && (<Tag color="#108ee9">推荐</Tag>)
                                      }
                                      {
                                        orderedDeployId == item.id + '' && (<Tag color="#87d068">已开通</Tag>)
                                      }
                                    </Space>
                                    <div style={{textAlign: 'left'}}>{item.subTitle}</div>
                                  </Space>
                                </Space>
                              )}
                              description={<div
                                style={{textAlign: "left", height: 'calc(100vh - 390px)', overflow: 'auto'}}
                                dangerouslySetInnerHTML={{__html: item.content}}></div>}
                              value={item.id + ''}
                            />
                          )
                        })
                      }
                    </CheckCard.Group>
                  </Form.Item>
                </div>
              </div>
            </ProCard>
            <Row style={{}}>
              <Col span={24}>
                <Card style={{paddingTop: 2, textAlign: "center"}} styles={{body: isMobile ? {padding: 0} : undefined}}>
                  <Space direction={isMobile ? 'vertical' : 'horizontal'}>
                    {
                      fromPage !== 'customer' && (
                        <Form.Item style={{marginTop: 20}} name={'enterpriseName'} label={'企业名称'} rules={[
                          {
                            required: true,
                            message: '请输入企业名称',
                          },
                        ]}>
                          <Select
                            showSearch={true}
                            filterOption={false}
                            onSearch={handleSearch}
                            options={enterpriseNameOptions}
                            placeholder={'请填写完整企业名称'}
                            style={{width: 300}}
                            defaultActiveFirstOption={false}
                            suffixIcon={null}
                            notFoundContent={enterpriseNameFetching ? <Spin size="small" /> : '未找到相关企业'}
                          />
                          {/*<Input size={"large"} style={{width: 300}} placeholder={'请填写完整企业名称'}/>*/}
                        </Form.Item>
                        // <>
                        //     <Form.Item style={{marginTop: 0, marginLeft: isMobile ? '10px' : ''}} name={'enterpriseName'} label={'企业名称'} rules={[
                        //       {
                        //         required: true,
                        //         message: '请输入企业名称',
                        //       },
                        //     ]}>
                        //       <Input size={"large"} style={{width: 300}} placeholder={'请填写完整企业名称'}/>
                        //     </Form.Item>
                        //     <Form.Item style={{marginTop: 0}} name={'enterpriseCode'} label={'企业信用代码'} rules={[
                        //       {
                        //         required: true,
                        //         message: '请输入统一社会信用代码',
                        //       },
                        //     ]}>
                        //       <Input size={"large"} style={{width: 300}} placeholder={'请填写统一社会信用代码'}/>
                        //     </Form.Item>
                        // </>
                      )
                    }
                    <Form.Item>
                      {
                        currentProductEnv && currentProductEnv.code === 'PREVIEW_ENV' && fromPage !== 'customer' && (
                          <Button
                            style={isMobile ? {width: 150} : {width: 150, marginTop: 20, marginLeft: 10}}
                            type="primary"
                            size={"large"}
                            onClick={async () => {
                              console.log({result})
                              if (!result.deployId) {
                                return message.error('请至少选择一个产品环境');
                              }
                              const fieldsValue = await form.validateFields();
                              if (!form.getFieldValue('enterpriseName') || form.getFieldValue('enterpriseName').trim().length === 0) {
                                return message.error('请填写企业名称');
                              }
                              // if (!form.getFieldValue('enterpriseCode') || form.getFieldValue('enterpriseCode').trim().length === 0) {
                              //   return message.error('请填写统一社会信用代码');
                              // }

                              let modelForConfirm = modal.confirm({
                                centered: true,
                                title: '系统提示',
                                icon: <ExclamationCircleOutlined/>,
                                content: (
                                  <Space direction={"vertical"}>
                                    <h3>确定要开通吗？</h3>
                                  </Space>
                                ),
                                okText: '确定',
                                cancelText: '取消',
                                onOk: async () => {
                                  let res;
                                  const regCode = getStoredRegCode();
                                  if (fromPage === 'admin') {
                                    res = await createEnvFromPlatform({
                                      enterpriseId: enterpriseId,
                                      enterpriseName: form.getFieldValue('enterpriseName'),
                                      bizId: result.deployId,
                                      bizType: 'PRODUCT_ENV',
                                      ...(regCode ? {regCode} : {}),
                                    });
                                  } else {
                                    res = await createEnvFromPlatform({
                                      enterpriseId: initialState?.currentUser?.enterpriseId || currentUserTemp.enterpriseId,
                                      enterpriseName: form.getFieldValue('enterpriseName'),
                                      mobile: initialState?.currentUser?.mobile,
                                      bizId: result.deployId,
                                      bizType: 'PRODUCT_ENV',
                                      ...(regCode ? {regCode} : {}),
                                    });
                                  }

                                  if (res === true) {
                                    modelForConfirm.destroy();
                                    if (isMobile) {
                                      setShowProcessEnv(true);
                                      return;
                                    }
                                    if (fromPage === 'admin') {
                                      setShowProcessEnv(true);
                                    } else {
                                      let host = location.host
                                        .replace('platform.', '');
                                      console.log(initialState?.envInfo?.env, 'initialState?.envInfo?.env')
                                      if(host==='iswan.cc'){
                                        host = 'prod.iswan.cc';
                                      }
                                      location.href = appendRegCodeToUrl('https://' + initialState?.currentUser?.enterpriseCode + '.'+host+'/edatlink-admin/');
                                    }
                                    return;
                                  }
                                }
                              });
                            }}
                          >
                            立 即 开 通
                          </Button>
                        )
                      }

                      {
                        currentProductEnv && currentProductEnv.code === 'PREVIEW_ENV' && fromPage === 'customer' && (
                          <Button
                            style={isMobile ? {width: 150} : {width: 150, marginTop: 20, marginLeft: 10}}
                            type="primary"
                            size={"large"}
                          >
                            已 开 通
                          </Button>
                        )
                      }

                      {
                        currentProductEnv && currentProductEnv.code !== 'PREVIEW_ENV' && (
                          <Button
                            style={isMobile ? {width: 150} : {width: 150, marginTop: 20, marginLeft: 10}}
                            type="primary"
                            size={"large"}
                            onClick={async () => {
                              ContactUtils.load();
                              ContactUtils.showDialog();
                              ContactUtils.openDialog()
                            }}
                          >
                            联系客服开通
                          </Button>
                        )
                      }
                    </Form.Item>
                  </Space>
                </Card>
              </Col>
            </Row>
          </Form>
        )
      }
      {contextHolder}


      {formValues && Object.keys(formValues).length ? (
        <EnterpriseAuthForm
          onSuccess={async () => {
            handleUpdateModalVisible(false);
            setFormValues({});
          }}
          onCancel={() => {
            handleUpdateModalVisible(false);
            setFormValues({});
          }}
          updateModalVisible={updateModalVisible}
          formValues={formValues}
        />
      ) : null}
      <CustomerModal
        onSuccess={async () => {
          setVisibleForCustomer(false);
        }}
        onCancel={() => {
          setVisibleForCustomer(false);
        }}
        updateModalVisible={visibleForCustomer}
      />

    </>
  );
};

export default PrepareEnv;
